import { Link } from 'react-router-dom';
import { news } from '@/mocks/news';
import SectionTitle from '@/components/base/SectionTitle';
import { CategoryTag } from '@/components/feature/NewsCard';

export default function NewsBrief() {
  const [headline, ...rest] = news;

  return (
    <section className="bg-background-50">
      <div className="max-w-6xl mx-auto px-4 py-14 md:px-8 md:py-20">
        <SectionTitle
          eyebrow="News Flash"
          title="最新新闻快讯"
          desc="追踪深田咏美的最新动态、活动报道与媒体采访，第一时间了解她的一切。"
          linkText="进入新闻中心"
          linkTo="/news"
        />

        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2">
          <article className="group relative overflow-hidden rounded-lg border border-background-200 bg-background-50">
            <Link to={`/news/${headline.id}`} className="block cursor-pointer">
              <div className="relative h-64 w-full overflow-hidden bg-background-200 md:h-72">
                <img
                  src={headline.thumb}
                  alt={`${headline.title} 配图`}
                  title={`${headline.title} 深田咏美资讯`}
                  className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 to-transparent"></div>
                <div className="absolute inset-x-0 bottom-0 p-6">
                  <CategoryTag category={headline.category} />
                  <h3 className="mt-3 font-heading text-xl font-bold leading-snug text-background-50 md:text-2xl">
                    {headline.title}
                  </h3>
                </div>
              </div>
            </Link>
            <div className="p-6">
              <p className="line-clamp-2 text-sm leading-relaxed text-foreground-500">{headline.summary}</p>
              <div className="mt-4 flex items-center justify-between">
                <span className="flex items-center gap-1.5 text-xs text-foreground-400">
                  <i className="ri-time-line"></i>
                  {headline.date}
                </span>
                <Link
                  to={`/news/${headline.id}`}
                  className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 cursor-pointer"
                >
                  阅读全文
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </div>
          </article>

          <div className="flex flex-col gap-4">
            {rest.slice(0, 4).map((item) => (
              <article
                key={item.id}
                className="group flex gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-200 hover:bg-background-100/60"
              >
                <Link to={`/news/${item.id}`} className="shrink-0 cursor-pointer">
                  <div className="h-20 w-28 overflow-hidden rounded-md bg-background-200 md:h-24 md:w-36">
                    <img
                      src={item.thumb}
                      alt={`${item.title} 缩略图`}
                      title={`${item.title} 深田咏美动态`}
                      className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
                    />
                  </div>
                </Link>
                <div className="flex min-w-0 flex-1 flex-col justify-between">
                  <h3 className="font-heading text-sm font-bold leading-snug text-foreground-950 md:text-base">
                    <Link to={`/news/${item.id}`} className="line-clamp-2 transition-colors group-hover:text-primary-700 cursor-pointer">
                      {item.title}
                    </Link>
                  </h3>
                  <div className="mt-2 flex items-center gap-3">
                    <CategoryTag category={item.category} />
                    <span className="text-xs text-foreground-400">{item.date}</span>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}